import React from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { enAU } from 'date-fns/locale'
import FieldLabel from './FieldLabel'

export interface LabeledDateFieldProps {
  /** Caption rendered above the picker (label-at-top convention). */
  label: React.ReactNode
  value: Date | null
  onChange: (date: Date | null) => void
  required?: boolean
  disabled?: boolean
  /** Optional helper line under the picker. */
  helperText?: React.ReactNode
}

/**
 * A `FieldLabel` (label-at-top) paired with an MUI `DatePicker`, wrapping the
 * `LocalizationProvider` + `enAU` + `dd/MM/yyyy` + full-width boilerplate that
 * was repeated per date field. The standard admin add/edit date input.
 */
const LabeledDateField: React.FC<LabeledDateFieldProps> = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  helperText,
}) => (
  <>
    <FieldLabel required={required}>{label}</FieldLabel>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enAU}>
      <DatePicker
        value={value}
        onChange={onChange}
        disabled={disabled}
        format="dd/MM/yyyy"
        slotProps={{ textField: { fullWidth: true, helperText } }}
      />
    </LocalizationProvider>
  </>
)

export default LabeledDateField
